import { call, put, takeEvery } from 'redux-saga/effects';
import { message, notification } from 'antd';
import { fetchApi, fetchApiAuth } from '../utils/api';
import stripePromise from '../utils/stripeProvider';
import app from '../constants';
import history from '../utils/history';

import {
    horoscopeListSuccess,
    horoscopeListFailure,

    findUserHoroscopeSuccess,
    findUserHoroscopeFailure,

    userActiveHoroscopesSuccess,
    userActiveHoroscopesFailure,

    checkIfLiveSuccess,
    checkIfLiveFailure,

    userPreviousHoroscopesSuccess,
    userPreviousHoroscopesFailure,

    getNewSingleHoroscopeSuccess,
    getNewSingleHoroscopeFailure,

    moonsignLookupSuccess,
    moonsignLookupFailure,

    risingSignLookupSuccess,
    risingSignLookupFailure,

    getYearlyLifeEventSuccess,
    getYearlyLifeEventFailure,

    purchaseYearlyHoroscopeSuccess,
    purchaseYearlyHoroscopeFailure,

    getSpecialForecastSuccess,
    getSpecialForecastFailure,

} from './horoscopeActions';

const {
    HOROSCOPE_LIST_REQUEST,
    FIND_USER_HOROSCOPE_REQUEST,
    USER_ACTIVE_HOROSCOPES_REQUEST,
    CHECK_IF_LIVE_REQUEST,
    USER_PREVIOUS_HOROSCOPES_REQUEST,
    GET_NEW_SINGLE_HOROSCOPE_REQUEST,
    MOONSIGN_LOOKUP_REQUEST,
    RISING_SIGN_LOOKUP_REQUEST,
    GET_YEARLY_LIFE_EVENT_REQUEST,
    PURCHASE_YEARLY_HOROSCOPE_REQUEST,
    GET_SPECIAL_FORECAST_REQUEST,
} = require('./horoscopeActions').constants;

function* horoscopeList() {

    try {
        const response = yield call(fetchApiAuth, {
            method: 'GET',
            url: '/horoscope',
        });

        yield put(horoscopeListSuccess(response));
    } catch (e) {
        console.log('error', e);
        // message.error(e.response ? e.response.data.message : e);
        yield put(horoscopeListFailure(e.response ? e.response.data.message : e));
    }
}

function* findUserHoroscope() {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'GET',
            url: '/horoscope/find-user-horoscope',
        });

        yield put(findUserHoroscopeSuccess(response));
    } catch (e) {
        message.error('Error', e.response?.data?.message || 'Unable to find horoscope');
        yield put(findUserHoroscopeFailure(e.response ? e.response.data.message : e));
    }
}

function* userActiveHoroscopes(action) {
    const { refresh } = action.payload || false;
    const freePremiumParam = app.ENABLE_FREE_PREMIUM ? '&free_premium=1' : '';
    try {
        const response = yield call(fetchApiAuth, {
            method: 'GET',
            url: `horoscope/user-horoscopes?refresh=${refresh ? '1' : '0'}${freePremiumParam}`,
        });
        yield put(userActiveHoroscopesSuccess(response.data));
    } catch (e) {
        // showError('Error', e.response ? e.response.data.message : e);
        yield put(userActiveHoroscopesFailure(e.response ? e.response.data.message : e));
    }
}

function* checkIfLive() {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'GET',
            url: 'horoscope/live-streaming-status',
        });
        yield put(checkIfLiveSuccess(response));
    } catch (e) {
        message.error(e.response ? e.response.data.message : e);
        yield put(checkIfLiveFailure(e.response ? e.response.data.message : e));
    }
}

function* userPreviousHoroscopes() {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'GET',
            url: 'horoscope/user-horoscopes?refresh=1&previous=1',
        });
        yield put(userPreviousHoroscopesSuccess(response.data));
    } catch (e) {
        // showError('Error', e.response ? e.response.data.message : e);
        yield put(userPreviousHoroscopesFailure(e.response ? e.response.data.message : e));
    }
}

function* getNewSingleHoroscope(action) {
    const { timePeriod, horoscopeSign, userAuthenticated } = action.payload;
    const freePremiumParam = app.ENABLE_FREE_PREMIUM ? '?free_premium=1' : '';
    const url = userAuthenticated ? `/horoscope/user-new-single-horoscope/${timePeriod}/${horoscopeSign}${freePremiumParam}` : `/horoscope/new-single-horoscope/${timePeriod}/${horoscopeSign}${freePremiumParam}`;
    try {
        const response = yield call(userAuthenticated ? fetchApiAuth : fetchApi, {
            method: 'GET',
            url,
        });

        yield put(getNewSingleHoroscopeSuccess(response));
    } catch (e) {
        message.error('Error', e.response?.data?.message || 'Unable to find horoscope');
        yield put(getNewSingleHoroscopeFailure(e.response ? e.response.data.message : e));
    }
}

function* moonsignLookup(action) {
    const { dob, placeOfBirth } = action.payload.data;
    try {
        const response = yield call(fetchApi, {
            method: 'POST',
            url: '/moonsign-lookup',
            body: {
                date_of_birth: dob,
                place_of_birth: placeOfBirth,
            },
        });

        const { data } = response;

        yield put(moonsignLookupSuccess(data.moonsign));
    } catch (e) {
        yield put(moonsignLookupFailure(e.response ? e.response.data.message : e));
    }
}

function* risingSignLookup(action) {
    const { dob, placeOfBirth } = action.payload.data;
    try {
        const response = yield call(fetchApi, {
            method: 'POST',
            url: '/rising-sign-lookup',
            body: {
                date_of_birth: dob,
                place_of_birth: placeOfBirth,
            },
        });

        const { data } = response;
        yield put(risingSignLookupSuccess(data.risingSign));
    } catch (e) {
        yield put(risingSignLookupFailure(e.response ? e.response.data.message : e));
    }
}

function* getYearlyLifeEvent(action) {
    const { sign, year, partSlug, userAuthenticated } = action.payload;
    const freePremiumParam = app.ENABLE_FREE_PREMIUM ? '?free_premium=1' : '';
    const url = `/horoscope/yearly/${sign}/${year}/life-event/${partSlug}${freePremiumParam}`;

    try {
        const response = yield call(userAuthenticated ? fetchApiAuth : fetchApi, {
            method: 'GET',
            url,
        });
        yield put(getYearlyLifeEventSuccess(response.data.data));
    } catch (e) {
        const errorMessage = e.response?.data?.message || 'Unable to load life event';
        message.error(errorMessage);
        yield put(getYearlyLifeEventFailure(errorMessage));
    }
}

function* purchaseYearlyHoroscope(action) {
    const { horoscopeDataId, cardId, selectedLang } = action.payload;

    try {
        const response = yield call(fetchApiAuth, {
            method: 'POST',
            url: '/horoscope/yearly/purchase',
            body: {
                horoscope_data_id: horoscopeDataId,
                card_id: cardId,
            },
        });

        const responseData = response.data;

        // Handle 3D Secure if required
        if (responseData?.data?.type === 'requires_action' && responseData?.data?.client_secret) {
            const stripe = yield call(() => stripePromise);
            const { paymentIntent, error } = yield call([stripe, stripe.confirmCardPayment], responseData.data.client_secret);

            if (error) {
                const langError = selectedLang === 2 ? 'असफल' : 'Error';
                const langDescription = selectedLang === 2 ? 'भुगतान अधूरा रह गया' : 'Payment was incomplete';
                notification.error({ message: langError, description: langDescription });
                yield put(purchaseYearlyHoroscopeFailure({ message: error.message, error: 'PAYMENT_FAILED' }));
                return;
            }

            if (paymentIntent.status === 'succeeded') {
                yield put(purchaseYearlyHoroscopeSuccess(responseData));
                history.replace('/life-event-confirmation');
            } else {
                yield put(purchaseYearlyHoroscopeFailure({ message: 'Payment not completed', error: 'PAYMENT_INCOMPLETE' }));
            }
        } else if (responseData?.data?.type === 'succeeded' || responseData?.success) {
            yield put(purchaseYearlyHoroscopeSuccess(responseData));
            history.replace('/life-event-confirmation');
        } else {
            yield put(purchaseYearlyHoroscopeSuccess(responseData));
            history.replace('/life-event-confirmation');
        }
    } catch (e) {
        const errorMessage = e.response?.data?.message || 'Unable to complete purchase';
        const langError = selectedLang === 2 ? 'असफल' : 'Error';
        notification.error({ message: langError, description: errorMessage });
        yield put(purchaseYearlyHoroscopeFailure({
            message: errorMessage,
            error: e.response?.data?.error || 'UNKNOWN_ERROR',
        }));
    }
}

function* getSpecialForecast(action) {
    const { sign, frequency, period, slug, userAuthenticated } = action.payload;
    const freePremiumParam = app.ENABLE_FREE_PREMIUM ? '?free_premium=1' : '';
    const url = `/horoscope/${sign}/special-forecast/${frequency}/${period}/${slug}${freePremiumParam}`;

    try {
        const response = yield call(userAuthenticated ? fetchApiAuth : fetchApi, {
            method: 'GET',
            url,
        });
        yield put(getSpecialForecastSuccess(response.data.data));
    } catch (e) {
        const errorMessage = e.response?.data?.message || 'Unable to load special forecast';
        message.error(errorMessage);
        yield put(getSpecialForecastFailure(errorMessage));
    }
}

export default function* authSaga() {
    yield* [
        takeEvery(HOROSCOPE_LIST_REQUEST, horoscopeList),
        takeEvery(FIND_USER_HOROSCOPE_REQUEST, findUserHoroscope),
        takeEvery(USER_ACTIVE_HOROSCOPES_REQUEST, userActiveHoroscopes),
        takeEvery(CHECK_IF_LIVE_REQUEST, checkIfLive),
        takeEvery(USER_PREVIOUS_HOROSCOPES_REQUEST, userPreviousHoroscopes),
        takeEvery(GET_NEW_SINGLE_HOROSCOPE_REQUEST, getNewSingleHoroscope),
        takeEvery(MOONSIGN_LOOKUP_REQUEST, moonsignLookup),
        takeEvery(RISING_SIGN_LOOKUP_REQUEST, risingSignLookup),
        takeEvery(GET_YEARLY_LIFE_EVENT_REQUEST, getYearlyLifeEvent),
        takeEvery(PURCHASE_YEARLY_HOROSCOPE_REQUEST, purchaseYearlyHoroscope),
        takeEvery(GET_SPECIAL_FORECAST_REQUEST, getSpecialForecast),
    ];
}
